import { render, staticRenderFns } from "./AdvertisementsMetrics.vue?vue&type=template&id=3a0f91c7&"
import script from "./AdvertisementsMetrics.vue?vue&type=script&lang=js&"
export * from "./AdvertisementsMetrics.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementsMetrics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports